<template>
<div class="column-control-root" :class="{ 'wn-list__sort': !bootstrap3 }"
    :draggable="!!colKey" @click.prevent="$emit('click')"
    @dragstart="onDragStart" @dragover="onDragOver" @dragend="clearMarks" @drop.prevent="onDrop">
    <slot></slot>
    <div class="column-controls" v-if="bootstrap3">
        <span class="icon is-small">
            <i v-if="direction === 'desc' && isActive" class="fa fa-sort-desc"></i>
            <i v-else-if="direction === 'asc' && isActive" class="fa fa-sort-asc"></i>
            <i v-else class="fa fa-sort"></i>
        </span>
    </div>
    <!-- always rendered (hidden when inactive) so the column keeps its width when the sort arrow moves -->
    <i v-else :class="[direction === 'asc' ? 'ri-arrow-up-line' : 'ri-arrow-down-line', { invisible: !isActive }]"></i>
</div>
</template>

<script>
// the column being dragged; headers can't read dataTransfer while dragging over, so it is shared here
let dragging = null;

const cells = (el, key) => el.closest('table').querySelectorAll(`[col="${ key }"]`);
const mark = (el, key, cls) => cells(el, key).forEach((cell) => cell.classList.add(cls));
const clearMarks = () => document.querySelectorAll('.is-col-dragging, .is-col-drop-left, .is-col-drop-right').forEach((cell) => cell.classList.remove('is-col-dragging', 'is-col-drop-left', 'is-col-drop-right'));

export default {
    // without this, Vue doesn't know 'click' is a declared custom event, so a parent's @click
    // listener is treated as both a native DOM attribute fallthrough AND the emitted event -
    // firing the handler twice per physical click (e.g. setSort() toggling direction, then
    // immediately toggling it back).
    emits: ['click', 'reorder'],
    data: () => ({ bootstrap3: window.wisenetwork?.bootstrap3 || false }),
    props: {
        // set to make the header draggable; dropping another header on it emits reorder({ from, to })
        colKey: {
            type: String,
            required: false,
            default: null,
        },
        isActive: {
            type: Boolean,
            required: false,
            default: false,
        },
        direction: {
            type: String,
            required: false,
            default: null,
        }
    },
    methods: {
        clearMarks,
        onDragStart(event) {
            if (!this.colKey) return;

            event.dataTransfer.setData('text/wn-col', this.colKey);
            event.dataTransfer.effectAllowed = 'move';
            dragging = this.colKey;
            // after a tick, so the browser's drag image is taken from the undimmed header
            setTimeout(() => mark(this.$el, dragging, 'is-col-dragging'));
        },
        onDragOver(event) {
            if (!this.colKey || !dragging) return;

            event.preventDefault();
            const ths = [...this.$el.closest('tr').children];
            const side = ths.indexOf(this.$el.closest('table').querySelector(`th[col="${ dragging }"]`)) < ths.indexOf(this.$el.closest('th')) ? 'right' : 'left';

            document.querySelectorAll('.is-col-drop-left, .is-col-drop-right').forEach((cell) => cell.classList.remove('is-col-drop-left', 'is-col-drop-right'));
            if (dragging !== this.colKey) mark(this.$el, this.colKey, `is-col-drop-${ side }`);
        },
        onDrop(event) {
            const from = event.dataTransfer.getData('text/wn-col');

            clearMarks();
            dragging = null;
            if (!this.colKey || !from || from === this.colKey) return;

            this.$emit('reorder', { from, to: this.colKey });
            // the moved column fades from the accent colour, so it is clear what moved
            this.$nextTick(() => {
                mark(this.$el, from, 'is-col-moved');
                setTimeout(() => cells(this.$el, from).forEach((cell) => cell.classList.remove('is-col-moved')), 800);
            });
        },
    },
}
</script>

<style scoped>
.column-control-root {
    display: inline-flex;
    user-select: none;
    cursor: pointer;
    gap: 7px;
}

.column-controls .fa-sort {
    color: #b3b3b3;
}
</style>